import { Box } from '@mui/material'
import React, { memo, useEffect } from 'react'
import { useReward } from 'react-rewards'

const AnimateRewards = () => {
  const { reward } = useReward('reward-container', 'confetti', {
    lifetime: 270,
    decay: 0.9,
    startVelocity: 45,
    elementCount: 90,
    elementSize: 7
  })

  useEffect(() => {
    reward()
  }, [])

  return (
    <Box
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <span id='reward-container' />
    </Box>
  )
}

export default memo(AnimateRewards)
